import { useSelector } from "react-redux";
import { useAppDispatch } from "hooks/hooks";
import Modal from "components/Modal/Modal";
import { toast } from "react-toastify";
import { deleteMessage, deleteMessageById, selectMessageForDeletion, selectState, setDeleteMessageModalOpen } from "../chat.slice";
import { useEffect } from "react";

interface IProps {
  setClickOutsideActive: React.Dispatch<React.SetStateAction<boolean>>;
}

const DeleteMessageModal = (
  { setClickOutsideActive }: IProps
) => {
  const { deleteMessageModalOpen } = useSelector(selectState);
  const message = useSelector(selectMessageForDeletion);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (deleteMessageModalOpen) {
      setClickOutsideActive(false);
    }
  }, [deleteMessageModalOpen, setClickOutsideActive])

  const close = () => {
    setClickOutsideActive(true);
    dispatch(setDeleteMessageModalOpen({ visible: false, index: -1 }));
  };

  const doDelete = async () => {
    try {
      if (message) {
        await dispatch(deleteMessage(message.message.messageId));
        dispatch(deleteMessageById(message.message.messageId));
        toast.success("Uspešno obrisana poruka.");
        close();
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Modal
      isOpen={deleteMessageModalOpen}
      onClick={doDelete}
      onClose={close}
      title="Brisanje poruke"
    >
      <p className="info-msg">
        Da li ste sigurni da želite da obrišete datu poruku?
        <br />
        <br />
      </p>
    </Modal>
  );
};

export default DeleteMessageModal;
